import moment from 'moment'
import dateformat from 'dateformat'

const MASK = 'DD/MM/YYYY'
const APIMASK = 'YYYY-MM-DD'
const TIMEMASK = 'DD/MM/YYYY HH:MM'
const ISODATETIME = 'yyyy-mm-dd HH:MM:ss'

export const apificateDate = (string) => {
  let m = moment(string, MASK, true)
  if (!m.isValid()) return null
  return m.format(APIMASK)
}

export const formatDateTimeISO = (string) => {
  var date = new Date(string)
  var datetoisodatetime = dateformat(date, ISODATETIME)
  return datetoisodatetime
}

export const formatDate = (string) => {
  if (typeof string !== 'undefined' && string) {
    let m = moment(string, [ MASK, APIMASK ], true)
    if (!m.isValid()) return null
    return m.format(MASK)
  }
  return undefined
}

export const formatDatetime = (string) => {
  let m = moment(string)
  if (!m.isValid()) return null
  return m.format(TIMEMASK)
}

export const formatNow = () => {
  return moment().format(MASK)
}

export const formatNowApi = () => {
  return moment().format(APIMASK)
}

export const formatAgo = (value, granularity = 'days') => {
  let ago = moment()
  ago.subtract(value, granularity)
  return ago.format(MASK)
}
